import { createClient } from '@supabase/supabase-js';
import { get, set, del } from 'idb-keyval';

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const tipoEnlaceAuth = new URLSearchParams(window.location.hash.slice(1)).get('type');

if (
  (tipoEnlaceAuth === 'invite' || tipoEnlaceAuth === 'recovery') &&
  window.location.pathname !== '/set-new-password'
) {
  window.history.replaceState(null, '', `/set-new-password${window.location.hash}`);
}

const idbStorage = {
  getItem: (key: string) => get<string>(key).then((v) => v ?? null),
  setItem: (key: string, value: string) => set(key, value),
  removeItem: (key: string) => del(key),
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'bookoll-auth',
    storage: idbStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});